import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { ThemeProvider } from './lib/theme';
import { Protected, Public } from './lib/auth-guards';
import { useAuthState } from './hooks/use-auth-state';
import { NotFound } from './pages/NotFound';

// Pages
function RootRoute() {
  const { isAuthenticated, isLoaded } = useAuthState();
  
  if (!isLoaded) {
    return null; // or a loading spinner
  }
  
  return isAuthenticated ? <Navigate to="/jobs" replace /> : <Landing />;
}

import Landing from './pages/Landing';
import { Index } from './pages/Index';
import { Archived } from './pages/Archived';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import { SignInPage } from './pages/auth/sign-in';
import { SignUpPage } from './pages/auth/sign-up';
import { CallbackPage } from './pages/auth/callback';
import { ResetPasswordPage } from './pages/auth/reset-password';
import RecommendedJobs from './pages/RecommendedJobs';
import Profile from './pages/Profile';

export default function App() {
  return (
    <ThemeProvider>
      <Routes>
        {/* Auth routes - must come first */}
        <Route path="/auth/callback" element={<CallbackPage />} />
        <Route
          path="/sign-in"
          element={
            <Public>
              <SignInPage />
            </Public>
          }
        />
        <Route
          path="/sign-up"
          element={
            <Public>
              <SignUpPage />
            </Public>
          }
        />
        {/* Not wrapped in <Public>: the recovery link establishes a session,
            and the user still needs to land here to set a new password. */}
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Public routes */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route
          path="/"
          element={
            <RootRoute />
          }
        />

        {/* Protected routes */}
        <Route
          path="/jobs"
          element={
            <Protected>
              <Index />
            </Protected>
          }
        />
        {/* Temporarily hidden - Recommended page
        <Route
          path="/recommended"
          element={
            <Protected>
              <RecommendedJobs />
            </Protected>
          }
        />
        */}
        <Route
          path="/archived"
          element={
            <Protected>
              <Archived />
            </Protected>
          }
        />
        <Route
          path="/profile"
          element={
            <Protected>
              <Profile />
            </Protected>
          }
        />

        {/* 404 catch-all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </ThemeProvider>
  );
}
